import styled from 'styled-components';

import { LabelWrapper } from '@pkg/components/Sections/Profile/Chip/components/Label/styles';

export const GroupActivityLoaderWrapper = styled.div`
    display: grid;
    place-items: center;

    position: sticky;
    top: 0;
    left: auto;
    right: auto;
    z-index: 8;

    padding-top: 20px;

    pointer-events: none;

    * {
        pointer-events: all;
    }

    ${LabelWrapper} {
        font-weight: 700;
        font-size: 14px;
        line-height: 14px;
    }

    svg {
        width: auto;
        height: 100%;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        place-items: start;
        padding: 0;
        margin-bottom: 20px;
        top: 40px;
    }

    @media (min-width: 1187px) {
        place-items: center;
    }
`;
